'use client';
import { useState } from 'react';
import styles from './style.module.scss';
import Titles from './titles';
import Descriptions from './descriptions';

const games = [
    {
      title: "Hades",
      description: "A rogue-like dungeon crawler where you play as Zagreus, attempting to escape the Underworld.",
      speed: 1
    },
    {
      title: "Kamla",
      description: "An atmospheric first-person horror game set in a mysterious town.",
      speed: 1.2
    },
    {
      title: "Visage",
      description: "A psychological horror game set in a haunted house with a dark past.",
      speed: 2
    },
    {
      title: "Doom",
      description: "A fast-paced first-person shooter where players battle demonic forces in a sci-fi setting.",
      speed: 2.5
    },
    {
      title: "Sekiro",
      description: "An action-adventure game set in a reimagined late 1500s Sengoku period Japan.",
      speed: 1.3
    },
    {
      title: "Valorant",
      description: "A tactical first-person shooter game where players engage in team-based combat.",
      speed: 0.7
    }
  ];
  

export default function Projects() {
    const [selectedProject, setSelectedProject] = useState(null)
    return (
        <div className={styles.container}>
            <Titles data={games} setSelectedProject={setSelectedProject}/>
            <Descriptions data={games} selectedProject={selectedProject}/>
        </div>
    )
}